import { Mail, Phone } from "lucide-react";
import type { WorkOrderExternalSnapshot } from "@myapp/contract";

type Props = {
  mieter: WorkOrderExternalSnapshot["mieter"] | undefined;
};

/**
 * Read-only Mieter card. The phone number is the single most valuable tap on this screen — a
 * technician standing at a door needs to call, not read an underlined link — so it renders as a
 * real ≥48px action button, alongside email the same way.
 */
export const AppointmentMieterCard = ({ mieter }: Props) => {
  const hasAny = mieter?.name || mieter?.telefon || mieter?.email;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Mieter</p>

      {!hasAny ? (
        <p className="mt-1 text-base text-slate-400">—</p>
      ) : (
        <>
          {mieter?.name && <p className="mt-1 text-base font-medium text-slate-900">{mieter.name}</p>}

          {(mieter?.telefon || mieter?.email) && (
            <div className="mt-3 flex flex-wrap gap-2">
              {mieter?.telefon && (
                <a
                  href={`tel:${mieter.telefon.replace(/\s+/g, '')}`}
                  className="flex h-12 flex-1 items-center justify-center gap-2 rounded-xl bg-primary text-sm font-semibold text-white"
                >
                  <Phone size={16} aria-hidden="true" />
                  Anrufen
                </a>
              )}
              {mieter?.email && (
                <a
                  href={`mailto:${mieter.email}`}
                  className="flex h-12 flex-1 items-center justify-center gap-2 rounded-xl border border-primary text-sm font-semibold text-primary"
                >
                  <Mail size={16} aria-hidden="true" />
                  E-Mail
                </a>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};
